import { render, staticRenderFns } from "./BoxSelect.vue?vue&type=template&id=069fd2a5&scoped=true"
import script from "./BoxSelect.vue?vue&type=script&lang=js"
export * from "./BoxSelect.vue?vue&type=script&lang=js"
import style0 from "./BoxSelect.vue?vue&type=style&index=0&id=069fd2a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069fd2a5",
  null
  
)

export default component.exports